import React from 'react';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ACCENT_BLUE } from './qcTheme';
import {
  QcIssueCategory,
  QC_ISSUE_CATEGORY_LABELS,
  QC_ISSUE_CATEGORY_ORDER,
} from '../../../interfaces/qcIssue.interface';

// Issue Type picker: outlined select with notched floating label and custom caret; composer (44px) and card editor (40px).
const SelectWrap = styled('span')({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
});

const FloatingLabel = styled('span')({
  position: 'absolute',
  top: '-7px',
  left: '9px',
  background: '#fff',
  padding: '0 5px',
  fontSize: '0.72rem',
  color: 'rgba(0,0,0,0.6)',
  lineHeight: 1,
  pointerEvents: 'none',
});

const NativeSelect = styled('select', {
  shouldForwardProp: prop => prop !== 'height',
})<{ height: number }>(({ height }) => ({
  appearance: 'none',
  WebkitAppearance: 'none',
  height: `${height}px`,
  minWidth: '240px',
  border: '1px solid rgba(0,0,0,0.3)',
  borderRadius: '6px',
  padding: '0 40px 0 14px',
  fontFamily: 'inherit',
  fontSize: '0.9rem',
  color: 'rgba(0,0,0,0.87)',
  background: '#fff',
  cursor: 'pointer',
  outline: 'none',
  '&:hover': {
    borderColor: 'rgba(0,0,0,0.87)',
  },
  '&:focus': {
    borderColor: ACCENT_BLUE,
    boxShadow: `inset 0 0 0 1px ${ACCENT_BLUE}`,
  },
}));

const Caret = styled(ExpandMoreIcon)({
  position: 'absolute',
  right: '12px',
  fontSize: '22px',
  color: 'rgba(0,0,0,0.54)',
  pointerEvents: 'none',
});

export interface QcCategorySelectProps {
  value: QcIssueCategory;
  height?: number;
  onChange: (category: QcIssueCategory) => void;
}

export default function QcCategorySelect({ value, height = 44, onChange }: QcCategorySelectProps): JSX.Element {
  return (
    <SelectWrap>
      <FloatingLabel>Issue Type</FloatingLabel>
      <NativeSelect
        height={height}
        aria-label='Issue Type'
        value={value}
        onChange={event => onChange(event.target.value as QcIssueCategory)}
      >
        {QC_ISSUE_CATEGORY_ORDER.map(category => (
          <option key={category} value={category}>{QC_ISSUE_CATEGORY_LABELS[category]}</option>
        ))}
      </NativeSelect>
      <Caret />
    </SelectWrap>
  );
}
